'use strict';

var _ = require('lodash');
var SummaryTopOppRecapAggregationFactory = function SummaryTopOppRecapAggregationFactory(AbstractROMServiceAggregationFactory, RomSummaryTopOppGridService) {
  function SummaryTopOppRecapAggregation() {
    AbstractROMServiceAggregationFactory.call(this, ['rom-summary-top-opp-spill-mode', 'rom-summary-top-opp-recap-mode'], 'rom-summary-top-recap');
  }
  SummaryTopOppRecapAggregation.prototype = Object.create(AbstractROMServiceAggregationFactory.prototype);
  SummaryTopOppRecapAggregation.constructor = SummaryTopOppRecapAggregation;
  SummaryTopOppRecapAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  SummaryTopOppRecapAggregation.prototype.aggregate = function (data) {
    var maxlimit = _.toNumber(RomSummaryTopOppGridService.getMaxOpps());
    return _.isEmpty(data) ? data : this.topOppAggregate(data, maxlimit);
  };
  return SummaryTopOppRecapAggregation;
};
SummaryTopOppRecapAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory', 'RomSummaryTopOppGridService'];
module.exports = SummaryTopOppRecapAggregationFactory;